module.exports = __webpack_public_path__ + "img/feature_buy_th.4f16d5d5.png";